import { render, staticRenderFns } from "./ManagePatient.vue?vue&type=template&id=52657aa8&scoped=true&"
import script from "./ManagePatient.vue?vue&type=script&lang=ts&"
export * from "./ManagePatient.vue?vue&type=script&lang=ts&"
import style0 from "./ManagePatient.vue?vue&type=style&index=0&id=52657aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52657aa8",
  null
  
)

export default component.exports